import { z } from 'zod';

/**
 * The member's own "hide me" switch — `PATCH /me/visibility`.
 *
 * **One field, and it is the member's own choice only.** `User.isAutoHidden` —
 * moderation's hold while reports are open — is read-only to every client and
 * has no place in a request body: a member who could send it would be lifting a
 * moderation action with one tap. `.strict()` is what refuses it.
 *
 * No default, deliberately. A body that omits the flag is a request that says
 * nothing, and defaulting it either way would make an empty `PATCH` silently
 * change the member's discoverability.
 */
export const SetHiddenSchema = z.object({ isHidden: z.boolean() }).strict();

export type SetHiddenRequest = z.infer<typeof SetHiddenSchema>;
